// extracted by mini-css-extract-plugin
module.exports = {"item":"NavbarSubItem_item__V78vS","itemTitle":"NavbarSubItem_itemTitle__3aVrw","itemBody":"NavbarSubItem_itemBody__6_3dc","itemBullet":"NavbarSubItem_itemBullet__7f1f1"};